import React,{useState,useEffect} from 'react';
import { useForm } from 'react-hook-form';
import clinicService from '../../../../../services/clinic.service';
import {toast} from 'react-toastify'
const ClinicServicesForm = (props) => {
    const { register, handleSubmit, setValue, formState:{errors} } = useForm(
        {
            defaultValues: props.clinicSettings
        }
    );
    const [clinicSettings, setClinicSettings] = useState(props.clinicSettings);
    const [isLoading, setIsLoading] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    const [isError, setIsError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        setClinicSettings(props.clinicSettings);
    }, [props.clinicSettings]);

    const onSubmit = (data) => {
        setIsLoading(true);
        for(const key in data){
           if(key ==="clinicId" || key ==="id"){
                //skip it
                continue
           }else{
                data[key]? data[key] = 1: data[key] = 0;
           }
            if(key ==="createdAt" || key ==="modifiedAt"){
                delete data[key];
            }
        }
        clinicService.updateSettings(clinicSettings.clinicId, data)
            .then(res => {
                setIsLoading(false);
                setIsSuccess(true);
                setIsError(false);
                setErrorMessage('');
                props.updateSettings(res.data)
                toast.success("Updating Settings",{
                    position:toast.POSITION.BOTTOM_RIGHT
                })
            })
            .catch(err => {
                setIsLoading(false);
                setIsSuccess(false);
                setIsError(true);
                setErrorMessage(err.response.data.message);
                toast.error("Error Updating Settings",{
                    position: toast.POSITION.BOTTOM_RIGHT
                })
            });
    };
    return ( 
        <>
            <form onSubmit={handleSubmit(onSubmit)}>
            <div className="col-sm-5  m-2">
                  <div className="form-check form-switch">
                      <input 
                        type="checkbox" 
                        className="form-check-input"
                        {...register("reminder")}
                        />
                      <label htmlFor="reminder" className="form-check-label">Reminders</label>
                  </div>
              </div>
              <div className="col-sm-5 m-2">
                  <div className="form-check form-switch">
                  <input 
                        type="checkbox" 
                        className="form-check-input"
                        {...register("recall")}
                        />
                      <label htmlFor="recall" className="form-check-label">Recalls</label>
                  </div>
              </div>

             

              <div className="col-sm-5 m-2">
                  <div className="form-check form-switch">
                  <input 
                        type="checkbox" 
                        className="form-check-input"
                        {...register("reputation")}
                        />
                      <label htmlFor="reputation" className="form-check-label">Reputation</label>
                  </div>
              </div>

              <div className="col-sm-5 m-2">
                  <div className="form-check form-switch">
                  <input 
                        type="checkbox" 
                        className="form-check-input"
                        {...register("survey")}
                        />
                      <label htmlFor="survey" className="form-check-label">Surveys</label>
                  </div>
              </div>
              <div className="col-sm-5 m-2">
                  <div className="form-check form-switch">
                  <input 
                        type="checkbox" 
                        className="form-check-input"
                        {...register("surveyReminder")}
                      
                        />
                      <label htmlFor="surveyReminder" className="form-check-label">Survey Reminders</label>
                  </div>
              </div>

              <div className="col-sm-5 m-2">
                  <div className="form-check form-switch">
                  <input 
                        type="checkbox" 
                        className="form-check-input"
                        {...register("booking")}
                        />
                      <label htmlFor="booking" className="form-check-label">Booking</label>
                  </div>
              </div>

              <div className="col-sm-5 m-2">
                  <div className="form-check form-switch">
                  <input 
                        type="checkbox" 
                        className="form-check-input"
                        {...register("twoWayText")}
                        />
                      <label htmlFor="twoWayText" className="form-check-label">Two-way Text</label>
                  </div>
              </div>

              <div className="col-sm-5 m-2">
                  <div className="form-check form-switch">
                  <input 
                        type="checkbox" 
                        className="form-check-input"
                        {...register("isAntispamLaw")}
                        />
                      <label htmlFor="covid" className="form-check-label">Anti Spam Law</label>
                  </div>
              </div>

              <div className="col-sm-5 m-2">
                  <div className="form-check form-switch">
                  <input 
                        type="checkbox" 
                        className="form-check-input"
                        {...register("reminderEmail")}
                        />
                      <label htmlFor="reminderEmail" className="form-check-label">Reminder Email</label>
                  </div>
              </div>

              <div className="col-sm-5 m-2">
                  <div className="form-check form-switch">
                  <input 
                        type="checkbox" 
                        className="form-check-input"
                        {...register("reminderCall")}
                        />
                      <label htmlFor="reminderCall" className="form-check-label">Reminder Call</label>
                  </div>
              </div>

              <div className="col-sm-5 m-2">
                  <div className="form-check form-switch">
                  <input 
                        type="checkbox" 
                        className="form-check-input"
                        {...register("reminderSms")}
                        />
                      <label htmlFor="reminderSms" className="form-check-label">Reminders Sms</label>
                  </div>
              </div>
              <div className="col-sm-5 m-2">
                  <div className="form-check form-switch">
                  <input 
                        type="checkbox" 
                        className="form-check-input"
                        {...register("newsletterEmail")}
                        />
                      <label htmlFor="newsletterEmail" className="form-check-label">NewsLetter Eamil</label>
                  </div>
              </div>
              <div className="col-sm-5 m-2">
                  <div className="form-check form-switch">
                  <input 
                        type="checkbox" 
                        className="form-check-input"
                        {...register("newsletterSms")}
                        />
                      <label htmlFor="newsletterSms" className="form-check-label">Newsletter Sms</label>
                  </div>
              </div>
              <div className="col-sm-5 m-2">
                  <div className="form-check form-switch">
                  <input 
                        type="checkbox" 
                        className="form-check-input"
                        {...register("blastEmail")}
                        />
                      <label htmlFor="blastEmail" className="form-check-label">Email Blast</label>
                  </div>
              </div>

              <div className="col-sm-5 m-2">
                  <div className="form-check form-switch">
                  <input 
                        type="checkbox" 
                        className="form-check-input"
                        {...register("blastSms")}
                        />
                      <label htmlFor="blastSms" className="form-check-label">Sms Blast</label>
                  </div>
              </div>

              <div className="col-sm-5 m-2">
                  <div className="form-check form-switch">
                  <input 
                        type="checkbox" 
                        className="form-check-input"
                        {...register("blastCall")}
                        />
                      <label htmlFor="blastCall" className="form-check-label">Call Blast</label>
                  </div>
              </div>
              <button type="submit" className="btn btn-secondary m-2">Save</button>
              </form>
        </>
     );
}
 
export default ClinicServicesForm;